import {MessageDescriptor, setupI18n} from '@lingui/core';
import {DateTime, DateTimeFormatOptions} from 'luxon';
import {createSelector} from 'reselect';

import {patchDateTimeFormat} from '../../helpers/dateTimeHelpers';
import {getLanguage} from '../data/dataSelectors';

/*
 * Selectors.
 */

type StringLocalizer = (id: MessageDescriptor) => string;
type DateTimeLocalizer = (dateTime: DateTime, format: DateTimeFormatOptions) => string;
export type Localizer = StringLocalizer & DateTimeLocalizer;

export const getI18n = createSelector(getLanguage, (language) =>
  setupI18n({
    language,
    catalogs: getLanguageCatalogs(),
  }),
);

export const getLocalize = createSelector(
  getI18n,
  (i18n): Localizer =>
    (descriptorOrDateTime: MessageDescriptor | DateTime, format?: DateTimeFormatOptions) => {
      // DateTime localization.
      if (DateTime.isDateTime(descriptorOrDateTime)) {
        return descriptorOrDateTime
          .setLocale(i18n.language)
          .toLocaleString(patchDateTimeFormat(format || DateTime.DATETIME_FULL));
      }

      // String localization.
      return i18n._(descriptorOrDateTime).trim();
    },
);

/*
 * String catalogs.
 */

/* eslint-env node */
/* eslint-disable global-require */
export function getLanguageCatalogs(): {[name: string]: any} {
  if (process.env.NODE_ENV === 'production') {
    return {
      // Lingui compiles the strings as the default export of an es6 native module.
      en: require('../../locales/en/messages').default,
    };
  }

  return {en: {}};
}
